'use strict';

var CmdDevice = require('./util/CmdDevice');
// var log = require('../../../log/Log').channel('Devio');

function Devio(ipAddress, username, password, onConnectStatus, onControlStatus,
    config) {
    // We modify the ports data here in the constructor because we may need to
    // change the port if it was defined in the config.

    this.ports = Object.assign([], Devio.prototype.ports);

    if (typeof config !== 'undefined' &&
        config !== null &&
        config.hasOwnProperty('port')) {
        this.port = config.port;
        this.ports[0].port = this.port;
    }

    CmdDevice.call(this, ipAddress, username, password, onConnectStatus,
        onControlStatus, config);
}

Devio.prototype = Object.create(CmdDevice.prototype);
Devio.prototype.constructor = Devio;

Devio.prototype.name = 'Devio';
Devio.prototype.key = '-LruJf_v6CasHh4pPfGp';
Devio.prototype.configName = 'devioControlChannels';
Devio.prototype.isAsync = false;
Devio.prototype.pollIntervalMs = 3000;
Devio.prototype.rejectAsync = false;
Devio.prototype.sendTerminator = '\n';
Devio.prototype.syncTimeoutMs = 3000;

Devio.prototype.pollParams = [ '$masterMicMute' ];

Devio.prototype.ports = [{
    port: 22,
    ssh: true,
    verifySend: 'DEVICE get macAddress',
    verifyConnection: /\+OK\s+"value":".+"/,
    verifyTimeoutMs: 10000,
    loginSkip: null,
    userPrompt: null,
    userPromptTimeoutMs: 0,
    userSend: null,
    userPromptHasNewline: false,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordPromptHasNewline: false,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
    loginVerifyTimeoutMs: 0,
}];

Devio.prototype.simulationParams = {
    caps: {
        hasFirmwareVersion: true,
        hasRoomMute: true,
    },
    configNotRequired: {
        roomMute: true,
    },
    firmwareVersion: '2.1.0.18',
};

Devio.prototype.commands = {};

Devio.prototype.commands.$appVersion = {};
Devio.prototype.commands.$appVersion.activeStates = [ 'initializing' ];
Devio.prototype.commands.$appVersion.activeInitializeStates =  [ 'gettingAppVersion' ];
Devio.prototype.commands.$appVersion.get = function() {
    this.sendCommand('$appVersion', 'DEVICE get appVersion');
};
Devio.prototype.commands.$appVersion.match = /\+OK\s+"value":"(.+)"/;
Devio.prototype.commands.$appVersion.process = function(match) {
    this.appVersion = match[1];
    this.doNextInitializeStep();
};

Devio.prototype.commands.$masterMicMute = {};
Devio.prototype.commands.$masterMicMute.activeStates = [ 'initializing', 'controlling' ];
Devio.prototype.commands.$masterMicMute.activeInitializeStates =  [ 'gettingMasterMicMute' ];
Devio.prototype.commands.$masterMicMute.get = function() {
    this.sendCommand('$masterMicMute', 'DEVICE get masterMicMute');
};
Devio.prototype.commands.$masterMicMute.set = function(value) {
    this.cmdSocket.removeSync('$masterMicMute');
    this.sendCommand('$masterMicMute', 'DEVICE get masterMicMute');
};
Devio.prototype.commands.$masterMicMute.match = /\+OK\s+"value":"(true|false)"/;
Devio.prototype.commands.$masterMicMute.process = function(match) {
    var newMute = match[1] === 'true';

    if (this.masterMicMute !== newMute) {
        this.masterMicMute = newMute;

        if (this.fsm.current === 'controlling') {
            this.broadcastStatus('mute', this.masterMicMute);
        }
    }

    if (this.fsm.current === 'initializing') {
        this.doNextInitializeStep();
    }
};

Devio.prototype.commands.firmwareVersion = {};
Devio.prototype.commands.firmwareVersion.get = function() {
    this.broadcastStatus('firmwareVersion', this.appVersion);
};

Devio.prototype.commands.mute = {};
Devio.prototype.commands.mute.get = function() {
    this.broadcastStatus('mute', this.masterMicMute);
};
Devio.prototype.commands.mute.set = function(value) {
    this.masterMicMute = value;
    this.broadcastStatus('mute', this.masterMicMute);
    this.cmdSocket.removeSync('mute');
    this.sendCommand('mute', 'DEVICE set masterMicMute ' + this.masterMicMute);
};
Devio.prototype.commands.mute.match = /^\+OK$/;

Devio.prototype.commands.ping = {};
Devio.prototype.commands.ping.activeStates = [ 'controlling', 'controlFailed' ];
Devio.prototype.commands.ping.get = function() {
    this.sendCommand('ping', 'DEVICE get systemTime');
};
Devio.prototype.commands.ping.match = /\+OK\s+"value":"\d+-\d+-\d+\s+\d+:\d+:\d+"/;

Devio.prototype.onComputeCaps = function() {
    var caps = this.getCapsTemplate();
    caps.hasFirmwareVersion = true;
    caps.hasRoomMute = true;
    return caps;
};

Devio.prototype.onInitialize = function() {
    this.mute = false;
    this.pollCycle = 0;

    this.startInitializer();
};

Devio.prototype.onPoll = function() {
    if (this.pollCycle < 0 || this.pollCycle >= this.pollParams.length) {
        this.pollCycle = 0;
    }

    this.query(this.pollParams[this.pollCycle]);
    this.pollCycle++;
};

Devio.prototype.onUpdateConfig = function() {
};

Devio.prototype.initializeSteps = [{
    state: 'gettingAppVersion',
    action: '$appVersion',
}, {
    state: 'gettingMasterMicMute',
    action: '$masterMicMute',
}, {
    state: 'finishingInitialization',
    action: function() {
        this.finishInitialization();
        return true;
    },
}];

module.exports = Devio;
